import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state/store';

export const selectCartEntries = ({ ordering }: RootState) => ordering.cart.cartEntries;

export const selectMinimalCartEntries = createSelector(
  [(state: RootState) => state.ordering.cart.minimalCartEntries],
  minimalCartEntries => minimalCartEntries
);
export const selectMinimalCartPricedStoreNumber = ({ ordering }: RootState) =>
  ordering.cart.minimalCartPricedStoreNumber;
export const selectPendingMinimalCartRepriceStoreNumber = ({ ordering }: RootState) =>
  ordering.cart.pendingMinimalCartRepriceStoreNumber;

export const selectIsPricingOrder = ({ ordering }: RootState) => ordering.cart.isPricingOrder;
export const selectPricedOrderId = ({ ordering }: RootState) => ordering.cart.pricedOrderId;
